// extracted by mini-css-extract-plugin
export default {"cls1":"UserForm-GridRow_cls1__wJN-H","cls2":"UserForm-GridRow_cls2__ZgR4r UserForm-GridRow_cls1__wJN-H"};